<div class="progress-bar-container">
    <div class="progress-bar" [style.width.%]="percentage" [class.empty]="percentage === 0">
      <span class="progress-text" [ngStyle]="{
        color: percentage === 0 ? 'black' : 'white',
        right: percentage > 0 ? '5px' : 'auto',
        left: percentage === 0 ? '5px' : 'auto'
      }">
        {{ percentage }}%
      </span>
    </div>
  </div>
  